export const RETURNS_REQUEST = 'RETURNS_REQUEST';
export const RETURNS_SUCCESS = 'RETURNS_SUCCESS';
export const RETURNS_FAILURE = 'RETURNS_FAILURE';

export const FORCE_RETURN_VALIDATION_REQUEST = 'FORCE_RETURN_VALIDATION_REQUEST';
export const FORCE_RETURN_VALIDATION_SUCCESS = 'FORCE_RETURN_VALIDATION_SUCCESS';
export const FORCE_RETURN_VALIDATION_FAILURE = 'FORCE_RETURN_VALIDATION_FAILURE';

export const RETURN_INFO_REQUEST = 'RETURN_INFO_REQUEST';
export const RETURN_INFO_SUCCESS = 'RETURN_INFO_SUCCESS';
export const RETURN_INFO_FAILURE = 'RETURN_INFO_FAILURE';

export const PAYOUT_REQUEST_REQUEST = 'PAYOUT_REQUEST_REQUEST';
export const PAYOUT_REQUEST_SUCCESS = 'PAYOUT_REQUEST_SUCCESS';
export const PAYOUT_REQUEST_FAILURE = 'PAYOUT_REQUEST_FAILURE';

export const PAYOUT_REQUEST = 'PAYOUT_REQUEST';
export const PAYOUT_SUCCESS = 'PAYOUT_SUCCESS';
export const PAYOUT_FAILURE = 'PAYOUT_FAILURE';

export const PUT_PAYOUT_STATUS_REQUEST = "PUT_PAYOUT_STATUS_REQUEST";
export const PUT_PAYOUT_STATUS_SUCCESS = "PUT_PAYOUT_STATUS_SUCCESS";
export const PUT_PAYOUT_STATUS_FAILURE = "PUT_PAYOUT_STATUS_FAILURE";

export const PRODUCT_LIST_REQUEST = "PRODUCT_LIST_REQUEST";
export const PRODUCT_LIST_SUCCESS = "PRODUCT_LIST_SUCCESS";
export const PRODUCT_LIST_FAILURE = "PRODUCT_LIST_FAILURE";

export const SALES_GROUP_REQUEST = "SALES_GROUP_REQUEST";
export const SALES_GROUP_SUCCESS = "SALES_GROUP_SUCCESS";
export const SALES_GROUP_FAILURE = "SALES_GROUP_FAILURE";

export const CURRENT_AFFILIATE_UPDATE = "CURRENT_AFFILIATE_UPDATE";
export const CURRENT_HASH_UPDATE = "CURRENT_HASH_UPDATE";

export const POST_HASH_REQUEST = "POST_HASH_REQUEST";
export const POST_HASH_SUCCESS = "POST_HASH_SUCCESS";
export const POST_HASH_FAILURE = "POST_HASH_FAILURE";

export const CLIENT_LIST_REQUEST = "CLIENT_LIST_REQUEST";
export const CLIENT_LIST_SUCCESS = "CLIENT_LIST_SUCCESS";
export const CLIENT_LIST_FAILURE = "CLIENT_LIST_FAILURE";

export const AFFILIATE_MEMBER_REQUEST = "AFFILIATE_MEMBER_REQUEST";
export const AFFILIATE_MEMBER_SUCCESS = "AFFILIATE_MEMBER_SUCCESS";
export const AFFILIATE_MEMBER_FAILURE = "AFFILIATE_MEMBER_FAILURE";

export const APP_USER_POST_REQUEST = "APP_USER_POST_REQUEST";
export const APP_USER_POST_SUCCESS = "APP_USER_POST_SUCCESS";
export const APP_USER_POST_FAILURE = "APP_USER_POST_FAILURE";

export const CLEAN_AFFILIATE_LIST = "CLEAN_AFFILIATE_LIST";

export const ITEM_LIST_REQUEST = "ITEM_LIST_REQUEST";
export const ITEM_LIST_SUCCESS = "ITEM_LIST_SUCCESS";
export const ITEM_LIST_FAILURE = "ITEM_LIST_FAILURE";

export const REGISTRATION_TERMS_REQUEST = "REGISTRATION_TERMS_REQUEST";
export const REGISTRATION_TERMS_SUCCESS = "REGISTRATION_TERMS_SUCCESS";
export const REGISTRATION_TERMS_FAILURE = "REGISTRATION_TERMS_FAILURE";

export const ACCEPT_OR_DECLINE_TERM = "ACCEPT_OR_DECLINE_TERM";
export const CLEAN_ACCEPTED_TERMS = "CLEAN_ACCEPTED_TERMS";

export const CLIENT_TERMS_AND_CONDITIONS_REQUEST = "CLIENT_TERMS_AND_CONDITIONS_REQUEST";
export const CLIENT_TERMS_AND_CONDITIONS_SUCCESS = "CLIENT_TERMS_AND_CONDITIONS_SUCCESS";
export const CLIENT_TERMS_AND_CONDITIONS_FAILURE = "CLIENT_TERMS_AND_CONDITIONS_FAILURE";

export const TermsAndConditionsModes = {
    AFFILIATE: 'affiliate'
};